/* eslint-disable */
/* tslint:disable */
import {ContentType, HttpClient, RequestParams} from "./http-client";

class Uploader<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
	/**
	 * No description
	 *
	 * @tags Загрузчик модулей
	 * @summary Получить пример файла
	 *
	 * Parameters
	 * @request GET:/uploader/module
	 * @secure
	 */
	uploaderGet = (params: RequestParams = {} ) =>
		this.request<any, void>({
			path: `/uploader/module`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Загрузчик модулей
	 * @summary Заполнение модулей приложения
	 * @request POST:/uploader/module
	 * @secure
	 */
	uploaderCreate = (data:{file:File},params: RequestParams = {},) =>
		this.request<any, void>({
			path: `/uploader/module`,
			method: "POST",
			type: ContentType.FormData,
			body: data,
			secure: true,
			format: "json",
			...params,
		});

}
export const uploaderAPI = new Uploader();
